import type { Theme } from '@fluentui/react-components'
import { createContext } from 'react'

export type ThemeMode = 'light' | 'dark'

export interface ThemeContextType {
  theme: Theme
  themeMode: ThemeMode
  isDark: boolean
  setThemeMode: (mode: ThemeMode) => void
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined)
